import { useLocalizationContext } from '../context';

export const useTranslate = () => {
  const { translate } = useLocalizationContext();

  return translate;
};
